import type { P1TimelineVM } from '../../view-models';
import type React from 'react';

export interface SequenceTimelineMiniProps {
  timeline: P1TimelineVM;
}

/**
 * Mini-timeline da sequência (.seq-timeline-mini) — converte cards-3.jsx verbatim.
 * DB: timeline-mini NÃO tem score por conversa → o dot colore por STATUS
 * (concluída vs em curso), não por risco. Nó atual (maior orderIndex) recebe 🚨.
 * Sem score/label fake.
 */
export function SequenceTimelineMini({ timeline }: SequenceTimelineMiniProps): React.JSX.Element {
  return (
    <div className="seq-timeline-mini">
      <div className="seq-timeline-mini__head">
        Sequência · <b>{timeline.totalConvs}</b> conversas em <b>{timeline.totalDaysLabel}</b>
      </div>
      <ol className="seq-timeline-mini__track">
        {timeline.nodes.map((n, i) => (
          <li
            key={n.convId}
            className={
              'seq-timeline-mini__node' + (n.current ? ' seq-timeline-mini__node--current' : '')
            }
          >
            <div
              className="seq-timeline-mini__dot"
              style={{ background: n.done ? 'var(--success-fg)' : 'var(--warning-fg)' }}
              aria-hidden="true"
            >
              {n.current ? '🚨' : ''}
            </div>
            <div className="seq-timeline-mini__label">
              <span>{i + 1}ª conversa</span>
              <span className="mono tweaks-hint">{n.atLabel}</span>
              <span className="tweaks-hint">{n.statusLabel}</span>
            </div>
            {i < timeline.nodes.length - 1 && (
              <div className="seq-timeline-mini__arrow" aria-hidden="true">
                →
              </div>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
}
